export default {
    deliveryTime: 'Ships within 24 hours',
    'category.empty.perex': 'Leave your email, we will inform you as soon as the product is ready',
    'category.empty.title': 'Subscribe to newsletter',

    'quantityDiscounts.ristre200g.12': '12 pieces',
    'quantityDiscounts.ristre200g.36': '36 pieces',

    'quantityDiscounts.ristre500g.6': '6 pieces',
    'quantityDiscounts.ristre500g.18': '18 pieces',

    priceWithoutVat: 'excl. VAT',

    minOrderQuantity: 'Min. order quantity',
    forPurchase: 'To purchase <strong>1 piece</strong>',
    pieces: 'pieces',
    buyOn: 'buy on',
}
